import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaChild, ISchemaProperty } from "../Schema";
import { NotEmptyString } from "../../../../Validation/Validation";
import SidePanelWorkstations from "../../layout/SidePanel/layouts/SidePanelWorkstations";
import { displayDateTime, isValidIsoDateString } from "../../../../helpers/DateHelper";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";

export const WorkstationSchema: ISchema = {
    displayName: "Workstations",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelWorkstations data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'name',
            displayName: 'Name',
            descriptor: true,
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function,
            validationError: "Name cannot be empty",
        } as ISchemaProperty,
        {
            name: 'assignedOperator',
            displayName: 'Current Operator / Status',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            defaultDisplayValue: "--"
        } as ISchemaProperty,
        {
            name: 'assignedSince',
            displayName: 'Assigned Since',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            defaultDisplayValue: "--",
            valueFormatter: (val: any) => isValidIsoDateString(val) ? displayDateTime(val) : '--'
        } as ISchemaProperty
    ],

    filters: [],

    children: [
        { entityName: EntityNames.workstationOuterCubes, displayName: "In Progress", cantView: false, viewType: EntityViewTypes.list, enableFilters: false, canAdd: false } as ISchemaChild,
        { entityName: EntityNames.partFullOuterCubes, displayName: "Request Part Full", cantView: false, viewType: EntityViewTypes.list, enableFilters: true, canAdd: false } as ISchemaChild,
    ],
}
